import { Colors } from '../../colors';
import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const BankBookLine = ({ width = 18, height = 18, fill = Colors.gray700, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 5.21011C2.25 4.80734 2.39023 4.46326 2.67068 4.17787C2.95127 3.89262 3.28957 3.75 3.68557 3.75L14.3144 3.75C14.7104 3.75 15.0487 3.89263 15.3293 4.17788C15.6098 4.46326 15.75 4.80734 15.75 5.21011L15.75 12.7899C15.75 13.1927 15.6098 13.5367 15.3293 13.8221C15.0487 14.1074 14.7104 14.25 14.3144 14.25L3.68557 14.25C3.28957 14.25 2.95127 14.1074 2.67068 13.8221C2.39023 13.5367 2.25 13.1927 2.25 12.7899L2.25 5.21011ZM3.44118 7.38462L14.5588 7.38462L14.5588 5.21011C14.5588 5.14791 14.5333 5.09097 14.4824 5.03928C14.4316 4.98745 14.3756 4.96154 14.3144 4.96154L3.68557 4.96154C3.62442 4.96154 3.56843 4.98745 3.51761 5.03928C3.46665 5.09097 3.44118 5.14791 3.44118 5.21011L3.44118 7.38462ZM3.44118 8.59615L3.44118 12.7899C3.44118 12.8521 3.46665 12.909 3.51761 12.9607C3.56843 13.0125 3.62442 13.0385 3.68557 13.0385L14.3144 13.0385C14.3756 13.0385 14.4316 13.0125 14.4824 12.9607C14.5333 12.909 14.5588 12.8521 14.5588 12.7899L14.5588 8.59615L3.44118 8.59615Z"
        fill={fill}
      />
    </Svg>
  );
};

export default BankBookLine;
